module.exports = __webpack_public_path__ + "img/icon_reg_2.1096caa0.png";